import { render } from "./FloatingAside.vue?vue&type=template&id=5f71528f&scoped=true"
import script from "./FloatingAside.vue?vue&type=script&lang=js"
export * from "./FloatingAside.vue?vue&type=script&lang=js"

import "./FloatingAside.vue?vue&type=style&index=0&id=5f71528f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f71528f"]])

export default __exports__